var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"type":"submit","variant":_vm.variant,"disabled":_vm.loading}},[(_vm.loading)?[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}),_vm._v(" Loading... ")]:[_vm._v(_vm._s(_vm.text))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }